import { createTheme, Theme, useMediaQuery } from "@mui/material";
import { createContext, FC, PropsWithChildren, useContext, useEffect, useMemo, useState } from "react";
import { getDesignTokens } from "./theme";
import { LocalStorage } from "../localStorage";

export type ThemeMode = 'light' | 'dark'

type ThemeContextType = {
    darkModeEnabled: boolean;
    setDarkModeEnabled: (mode: boolean) => void;
    theme: Theme
    isSmallScreen: boolean;
};


export const ThemeContext = createContext<ThemeContextType>({
    darkModeEnabled: false,
    setDarkModeEnabled: () => { },
    theme: createTheme({}),
    isSmallScreen: false
});

export const ThemeContextProvider: FC<PropsWithChildren> = ({ children }) => {

    const [darkModeEnabled, setDarkModeEnabled] = useState(LocalStorage.getIsDarkMode());

    const theme = useMemo(     
        () => createTheme( getDesignTokens(darkModeEnabled) ),
        [darkModeEnabled]
    );

    useEffect(() =>{
        LocalStorage.saveDarkMode(darkModeEnabled)
    }, [darkModeEnabled])

    const isSmallScreen: boolean =  useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <ThemeContext.Provider value={{ darkModeEnabled, setDarkModeEnabled, theme, isSmallScreen }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useThemeContext = () => {
    return useContext(ThemeContext);
  };
